module.exports = __webpack_public_path__ + "static/media/brand-11.191ae9c4.png";